'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import { NEXT_STEPS_SURVEY_UPGRADE_PRODUCTS } from 'ui-addon-upgrades/_core/common/constants/trials';
import Raven from 'Raven';
import { TRIAL_GUIDE_UPGRADE_PRODUCTS } from '../../common/constants/trials';
import { navigateTo } from '../../common/navigation/url';
import { getTrialGuideUrl } from '../../utils/links';
var SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY'
};

var TrialActivationSuccessContainer = function TrialActivationSuccessContainer(_ref) {
  var hideBackground = _ref.hideBackground,
      header = _ref.header,
      subText = _ref.subText,
      ctaText = _ref.ctaText,
      onSuccess = _ref.onSuccess,
      upgradeData = _ref.upgradeData,
      shouldHideSurvey = _ref.shouldHideSurvey,
      showIllustration = _ref.showIllustration,
      showSubtitle = _ref.showSubtitle,
      showTrialLoadingState = _ref.showTrialLoadingState;
  var upgradeProduct = upgradeData.upgradeProduct;

  var _useState = useState(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS),
      _useState2 = _slicedToArray(_useState, 2),
      successModalType = _useState2[0],
      setSuccessModalType = _useState2[1];

  useEffect(function () {
    if (!onSuccess) {
      Raven.captureMessage('Trial activation missing onSuccess callback', {
        extra: Object.assign({}, upgradeData)
      });
    }
  }, [onSuccess, upgradeData]);

  var maybeShowNextStepsSurvey = function maybeShowNextStepsSurvey() {
    var shouldShowNextStepsSurvey = NEXT_STEPS_SURVEY_UPGRADE_PRODUCTS.includes(upgradeProduct) && !shouldHideSurvey;

    if (shouldShowNextStepsSurvey) {
      setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
      return;
    } // If onSuccess is missing, try to bring users to trial guide


    if (!onSuccess) {
      if (TRIAL_GUIDE_UPGRADE_PRODUCTS.includes(upgradeProduct)) {
        navigateTo(getTrialGuideUrl(upgradeProduct));
      } else {
        Raven.captureMessage('Trial activation missing onSuccess and trial guide', Object.assign({}, upgradeData));
      }

      return;
    }

    onSuccess();
  };

  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return React.createElement(TrialActivationNextStepsModal, {
        onSuccess: onSuccess,
        upgradeData: upgradeData
      });

    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return React.createElement(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: header,
        subText: subText,
        ctaText: ctaText,
        showIllustration: showIllustration,
        showTrialLoadingState: showTrialLoadingState,
        showSubtitle: showSubtitle,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData
      });

    default:
      return null;
  }
};

TrialActivationSuccessContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool.isRequired,
  header: PropTypes.node,
  subText: PropTypes.node,
  ctaText: PropTypes.node,
  showIllustration: PropTypes.bool,
  shouldHideSurvey: PropTypes.bool,
  onSuccess: PropTypes.func,
  showSubtitle: PropTypes.bool,
  showTrialLoadingState: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationSuccessContainer;